// extracted by mini-css-extract-plugin
export var avatar = "_rv-3";
export var avatarContainer = "_rv-2";
export var avatarSpacer = "_rv-5";
export var avatarSpacerContainer = "_rv-4";
export var avatarStackContainer = "_rv-1";
export var bubble = "_rv-0";
export var remainderBubble = "_rv-6";